import { Link } from 'react-router-dom';

interface PortalBrandHeaderProps {
  name: string;
  logoUrl: string | null | undefined;
  primaryColor: string;
  /** Wrap the brand in a link (home) when given */
  to?: string;
  className?: string;
}

/** Logo-or-name block shared by the login page and the signed-in shell. */
export function PortalBrandHeader({ name, logoUrl, primaryColor, to, className }: PortalBrandHeaderProps) {
  const inner = logoUrl ? (
    <img src={logoUrl} alt={name} className="h-10 max-w-[200px] object-contain object-left" />
  ) : (
    <span className="text-lg font-bold leading-tight" style={{ color: primaryColor }}>{name}</span>
  );
  if (to) {
    return <Link to={to} className={className} aria-label={`${name} home`}>{inner}</Link>;
  }
  return <div className={className}>{inner}</div>;
}
